var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.styles, _vm.value === _vm.option.value? 'is-active': null],on:{"click":function($event){return _vm.$emit('input', _vm.option.value)}}},[_c('p',[_vm._v(_vm._s(_vm.option.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }